import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m11.381 2.291-5.574.003c-2.3.015-3.724 1.528-3.724 3.836v7.664c0 2.32 1.435 3.839 3.755 3.839l5.574-.003c2.3-.014 3.725-1.528 3.725-3.836V6.13c0-2.32-1.436-3.839-3.756-3.839",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12.055 10.03H6.038M8.334 6.55H6.038"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "13.915",
      cy: "12.39",
      r: "3.333",
      fill: "#fff",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      transform: "rotate(11.161 13.915 12.39)"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m15.68 15.287 1.845 2.488"
    }, null, -1)
  ]))]))
}
export default { render: render }